import * as actions from './garmentCustomiser/actions'
import * as mutations from './garmentCustomiser/mutations'
import * as getters from './garmentCustomiser/getters'

import { dataProps } from './garmentCustomiser/properties'

const state = {
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/garmentCustomiser.js